import { Component, Input } from '@angular/core';
import { BankAccountModel } from '../../models/user-info.model';
import { NgxBadgeModule } from '@digipay/ngx-badge';

@Component({
  selector: 'app-user-bank-card',
  standalone: true,
  imports: [NgxBadgeModule],
  templateUrl: './user-bank-card.component.html',
  styleUrl: './user-bank-card.component.scss',
})
export class UserBankCardComponent {
  @Input() bankAccountData: BankAccountModel;
}
